import { Pagination, Box } from "@mui/material";
import { checkMobile } from "../../../utils/utils";

export default function PageNum({ blogDatas, handlePageClick, pageRef }) {
  const is_phone = checkMobile();
  let style;
  if (is_phone) {
    style = {
      marginTop: "50px",
    };
  } else {
    style = {
      marginTop: "100px",
    };
  }
  return (
    <Box sx={{ display: "flex", justifyContent: "center", ...style }}>
      {blogDatas ? (
        <Pagination
          count={blogDatas.allPage}
          shape="rounded"
          onChange={handlePageClick}
          page={pageRef.current.pageNum}
          siblingCount={is_phone ? 0 : 1} // 显示页面点击按钮的多少
          // boundaryCount={1} // 分界线多少, 默认1
          // showFirstButton
          // showLastButton
          color="fourth"
          sx={{ maxWidth: "100%" }}
          size={is_phone ? "small" : "medium"}
        />
      ) : (
        ""
      )}
      {/* <Box
            sx={{ display: "flex", justifyContent: "center", marginTop: "50px" }}
          >
            {previousPage ? (
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  handleClick(e, -1);
                  sectionRef.current.scrollIntoView();
                }}
              >
                Prev
              </a>
            ) : (
              <a>Prev</a>
            )}
            <Typography
              sx={{ lineHeight: "140%", margin: "0 10px", color: "#ff8000" }}
            >
              {pageRef.current.pageNum}
            </Typography>
            {nextPage ? (
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  handleClick(e, 1);
                  sectionRef.current.scrollIntoView();
                }}
              >
                Next
              </a>
            ) : (
              <a>Next</a>
            )}
          </Box>
          <Box
            sx={{ display: "flex", justifyContent: "center", marginTop: "5px" }}
          >
            {blogDatas ? (
              <Typography sx={{ fontSize: "10px", margin: "20px 10px" }}>
                共{Math.ceil(blogDatas.count / 10)}页, {blogDatas.count}文章
              </Typography>
            ) : (
              ""
            )}
          </Box> */}
    </Box>
  );
}
